import { publicAxios } from "../../../config/apiConfig";
import {
  GET_ALL_SIZE_SUCCESS,
  GET_ALL_SIZE_REQUEST,
  GET_ALL_SIZE_FAILURE,
} from "./ActionType";

export const getAllSize = () => async (dispatch) => {
  dispatch({ type: GET_ALL_SIZE_REQUEST });
  try {
    const { data } = await publicAxios.get(`sizes`);
    dispatch({ type: GET_ALL_SIZE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_ALL_SIZE_FAILURE, payload: error.message });
  }
};
